import arrayToObject from "./common/helpers/arrayToObject";

const actionTypes = arrayToObject([
  // BEN_NOTE
  // This hasn't yet been integrated...

  // we'll delete all of these.  I'm envisioning one action for each of these
  // 1) hit an endpoint (url, method, json in, json out)
  // 2) update the redux store
  // there will probably be others, but you get the idea that we don't
  // want hundreds of actionTypes

  // effects, that generate actions
  "Effects/GET_REQUEST",
  "Effects/POST_REQUEST",
  "Effects/LOGIN_POST_REQUEST",
  "Effects/PUT_REQUEST",
  "Effects/DELETE_REQUEST",

  // Actions, triggered by views or effects
  "SET_IN_REDUX",
  "SET_USER_SELECTION",
  "DELETE_USER_SELECTION",

  // -- notification actions --
  // BEN_NOTE - I don't think we need these, but leaving them for now.
  "HIDE_NOTIFICATION",
  "SHOW_ERROR",
  "SHOW_INFO",
  "SHOW_SUCCESS",
  "SHOW_WARNING",
  "SHOW_COMPLEX_MODAL",

  // -- modal actions --
  "SHOW_MODAL",
  "HIDE_MODAL",
]);

export default actionTypes;
